import React, { FC } from 'react';
import { TeamID } from '../../../scripts/models/common';
import { TeamModel } from '../../../scripts/models/models';
import BarLines, { ILine } from './BarLines';

import TeamRow from './TeamRow';
import './TeamBarChart.scss';

interface IProps {
    teamSet: TeamModel[],
    data: Record<TeamID, number>,
    title: string,
    scale?: number,
    extraLines?: ILine[]
}

const TeamBarChart: FC<IProps> = (props) => {
    const { teamSet, data, title, scale = 1, extraLines } = props


    return (
        <div className={"WinsByTeamWrapper"}>
            <div className="WinsByTeamHeader titleText">{title}</div>
            <div style={{ position: "relative" }}>
                <div>{
                    teamSet.map((team, idx) => {
                        return <TeamRow team={team} value={data[team.id]} key={team.id} scale={scale} position={idx + 1} />
                    })}
                </div>
                <BarLines scale={scale} extraLines={extraLines} />
            </div>

        </div>
    )
}

export default TeamBarChart;